export default from './app-loaded';



// WEBPACK FOOTER //
// ./app/components/app-loaded/index.js